// extracted by mini-css-extract-plugin
module.exports = {"row":"_7a3fb80146--row--LerJb","key":"_7a3fb80146--key--Sb38i","value":"_7a3fb80146--value--nzxPf","warning":"_7a3fb80146--warning--vPwaC"};